// extracted by mini-css-extract-plugin
module.exports = {"noPlayers":"TestUsersTab_noPlayers__1-hIT"};